import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';

import { useSnackbar } from 'notistack';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { chanChoiceList, chanFullList  } from '../graphql/queries';

// get channels into list, set quiet to non-zero to silence
export const useChanList = (pgserial, quiet, vdebug) => {
    const { enqueueSnackbar } = useSnackbar();
    const [chlist, setChlist] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
          let wkpend = true;
          try {
              const cresult = await API.graphql({query: chanFullList});
              if (vdebug !== null) { console.log("useChanList response", cresult); }
              const wklist = cresult.data.listChannels.items.reduce(function(result,item) {
                  if (item.chtype !== null) {
                      result.push({
                          channelid: item.channelid,
                          chname: item.atype,
                          chtype: item.chtype,
                          chkey: item.chkey,
                          chlink: item.chlink,
                      });
                  }
                  return result;
                },[]);

              if (wkpend && wklist[0]) {
                  if (vdebug !== null) { console.log('list', wklist); }
                  wkpend = false;
                  setChlist(wklist);
                  if (!quiet) {
                      enqueueSnackbar(`showing ${wklist.length} channels`,
                        {variant: 'info', anchorOrigin: {vertical: 'bottom', horizontal: 'right'}} );
                  }

              }

          } catch (cresult) {
              if (vdebug !== null) { console.log("useChanList error", cresult); }
              enqueueSnackbar(`error retrieving channels`, {variant: 'error'});
          }
      };

      fetchData();

    }, [pgserial, quiet, enqueueSnackbar, vdebug]);

    return chlist;
};

// dictionary channel to lookup name using channelid
export const useChanDict = (vdebug) => {
    const { enqueueSnackbar } = useSnackbar();
    const [chdict, setChdict] = useState({});

    useEffect(() => {
      const fetchData = async () => {
          let wkpend = true;
          try {
              const cresult = await API.graphql({query: chanChoiceList});
              if (vdebug !== null) { console.log("useChanDict response", cresult); }
              const wkdict = cresult.data.listChannels.items.reduce(function(result,item) {
                  if (item.chtype !== null) {
                      result[item.channelid] = item.atype;
                  }
                  return result;
                },[]);

              if (wkpend) {
                  if (vdebug !== null) { console.log("dict", wkdict); }
                  wkpend = false;
                  setChdict(wkdict);
              }

          } catch (cresult) {
              if (vdebug !== null) { console.log("useChanDict error", cresult); }
              enqueueSnackbar(`error retrieving channels`, {variant: 'error'});
          }
      };

      fetchData();

    }, [enqueueSnackbar, vdebug]);

    return chdict;
};

// dictionary channel to lookup record info using name
export const useExtChanDict = (vdebug) => {
    const { enqueueSnackbar } = useSnackbar();
    const [chdict, setChdict] = useState({});

    useEffect(() => {
      const fetchData = async () => {
          let wkpend = true;
          try {
              const cresult = await API.graphql({query: chanChoiceList});
              if (vdebug !== null) { console.log("useExtChanDict response" , cresult); }

              const wkdict = cresult.data.listChannels.items.reduce(function(result,item) {
                  if (item.chtype !== null) {
                      result[item.atype] = item;
                  }
                  return result;
                },[]);

              if (wkpend) {
                  if (vdebug !== null) { console.log('chandict', wkdict); }
                  wkpend = false;
                  setChdict(wkdict);
              }

          } catch (cresult) {
              if (vdebug !== null) { console.log("useChanDict error", cresult); }
              enqueueSnackbar(`error retrieving channels`, {variant: 'error'});
          }
      };

      fetchData();

    }, [enqueueSnackbar, vdebug]);

    return chdict;
};


// takes props channels, currchan (value), setchan (function), allowall (optional)
export const ChannelChoice = props => (
    <Select aria-label="channel select" name="pchann" id="pchann" value={props.currchan}
              onChange={e => {props.setchan(e.target.value)} }>
               {(props.allowall) && <MenuItem key='all' value='all'>All Channels</MenuItem>}
              {props.channels.map(item => (
                  <MenuItem key={item.chname} value={item.chname}>{item.chname}({item.chtype})</MenuItem>
              ))}
    </Select>
);

